export { matchers } from './client-matchers.js';

export const nodes = [() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18')];

export const server_loads = [];

export const dictionary = {
	"/(app)": [4,[2]],
	"/(app)/about": [5,[2]],
	"/(app)/box": [6,[2]],
	"/(app)/contact": [7,[2]],
	"/(app)/credit": [8,[2]],
	"/(app)/disclaimer": [9,[2]],
	"/drop/[id]": [~18],
	"/(app)/game": [10,[2]],
	"/(app)/graveyard": [11,[2]],
	"/(guides)/guides": [16,[3]],
	"/(guides)/guides/[game]": [~17,[3]],
	"/(app)/new": [12,[2]],
	"/(app)/privacy-policy": [13,[2]],
	"/(app)/saves": [14,[2]],
	"/(app)/terms": [15,[2]]
};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};